import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/login/login-remember-me-constant';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models/login';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { LoginRememberMeUtilsService } from '../../../../utils/login/login-remember-me-utils.service';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithCredService {
  loginAuthHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.checkUsernamePassword+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: LoginRememberMeUtilsService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithCredentials = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    userInputFields: ILoginUserNamePasswordInput,
    rbaLogin = false
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const userNamePingFlow = this.buildUserName(userInputFields);
    const payload = this.buildPayload(
      authConfig,
      userNamePingFlow,
      userInputFields,
      rbaLogin
    );

    const getLoginPostWithCredentialsUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginPostWithCredentialsUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginPostWithCredentialsUrl
      }
    ];

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginPostWithCredentialsUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_CREDENTIALS_SERVICE')
      .withCredentials(true)
      .create();
  };

  private buildUserName(userInputFields: ILoginUserNamePasswordInput): string {
    return userInputFields.lastName
      ? `${userInputFields.userName}${userInputFields.lastName}`
      : userInputFields.userName;
  }

  private buildPayload(
    authConfig: OauthAEMConfig,
    userNamePingFlow: string,
    userInputFields: ILoginUserNamePasswordInput,
    rbaLogin: boolean
  ): PostWithCredentials {
    const useExtendedPayload =
      authConfig.VERSION_PARAMETER_VALUE === '3' || rbaLogin;
    return useExtendedPayload
      ? {
          username: userNamePingFlow,
          password: userInputFields.password,
          rememberMyUsername: userInputFields.rememberMe === 'Y',
          thisIsMyDevice: userInputFields.persistentLogin === 'Y'
        }
      : {
          username: userNamePingFlow,
          password: userInputFields.password
        };
  }
}
